import React, { useContext, useRef } from 'react';
import { subPageBus } from './event';
import { MaxContext } from './context';

export const SubPage = (_props: any) => {
  const container = useRef<HTMLDivElement>(null);
  const { pageCode } = useContext(MaxContext);

  const { debugCode, props = {} } = _props;
  const { style, ref: previewRef } = props;

  return (
    <div
      ref={(node) => {
        previewRef?.(node);
        container.current = node;
        if (node) {
          subPageBus.emit(pageCode);
        } else {
          subPageBus.removeListener(pageCode);
        }
      }}
      style={style}
      className="max-render-sub-page"
      id={pageCode}
      data-debugcode={debugCode}></div>
  );
};
